import { render, staticRenderFns } from "./HallNel.vue?vue&type=template&id=3b5294f8&scoped=true"
import script from "./HallNel.vue?vue&type=script&lang=js"
export * from "./HallNel.vue?vue&type=script&lang=js"
import style0 from "./HallNel.vue?vue&type=style&index=0&id=3b5294f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5294f8",
  null
  
)

export default component.exports